<template>
  <div class="MyBill">
    <div class="MyBill-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        账单
      </div>
      <div class="MyBill-head">
        <div class="MyBill-head-category MyBill-head-default" :class="this.Myfodx == '1' ? 'MyBill-head-folr' : ''">
          <el-select v-model="Mybalance" placeholder="请选择" @change="MyBalanTion()" @input="Myfontlr(1)">
            <el-option
              v-for="item in BalanceList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="MyBill-head-category" :class="this.Myfodx == '2' ? 'MyBill-head-folr' : ''">
          <el-select v-model="MyIntegral" placeholder="请选择" @change="MyIntegTion()" @input="Myfontlr(2)">
            <el-option
              v-for="item in IntegralList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="MyBill-fill"></div>
      <div class="MyBill-content" v-for="ermybifotn in mybifotn" :key="ermybifotn.ID">
        <router-link :to="{path: 'BillDetails',query: {mytrpe: ermybifotn.transactionname,myrant: ermybifotn.amount,mysaet: ermybifotn.typedetailmc,mysrmb: ermybifotn.cnumber,mytime: ermybifotn.entertime,mysebr: ermybifotn.serialnumber}}">
          <div class="MyBill-content-bill">
            <div class="MyBill-content-bill-imag MyBill-content-bill-Charge" v-if="ermybifotn.type == '1'">充</div>
            <div class="MyBill-content-bill-imag MyBill-content-bill-Convert" v-else-if="ermybifotn.type == '2'">消</div>
            <div class="MyBill-content-bill-imag MyBill-content-bill-Convert" v-else-if="ermybifotn.type == '3'">兑</div>
            <div class="MyBill-content-bill-imag MyBill-content-bill-Vanish" v-else-if="ermybifotn.type == '4'">转</div>
            <div class="MyBill-content-bill-tite">
              <p class="MyBill-content-bill-tite-text">
                <span>{{ermybifotn.cnumber}}</span>
                <span v-if="ermybifotn.type == '1'">{{ermybifotn.amount}}</span>
                <span v-else>{{ermybifotn.amount}}</span>
              </p>
              <p class="MyBill-content-bill-tite-time">{{ermybifotn.entertime}}</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + mybifail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{mybitips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + mybilong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      BalanceList: [{
        value: '2',
        label: '消费'
      }, {
        value: '4',
        label: '转账'
      }, {
        value: '1',
        label: '充欧宝'
      }, {
        value: '3',
        label: '兑欧宝'
      }],
      IntegralList: [{
        value: '2',
        label: '消费'
      }, {
        value: '4',
        label: '转账'
      }],
      Mybalance: '余额账单',
      MyIntegral: '积分账单',
      loginID: '',
      mybifail: 'none',
      mybitips: '',
      mybifotn: '',
      mytfbr: '',
      Myfodx: '1',
      mybilong: 'block'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收从卡包传过来的卡号
    this.mytfbr = this.$route.query.catfbr;
    // this.Mybalance = this.BalanceList[0].label;
    // this.MyIntegral = this.IntegralList[0].label;
    this.$axios.post('wx/oldBillList',this.$qs.stringify({
      token: this.loginID,
      transactiontype: '1',
      cnumber: this.mytfbr
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.mybilong = 'none';
      if(res.data.code == '200'){
        this.mybifotn = res.data.data;
      }else{
        this.mybitips = res.data.msg;
        this.mybifail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.mybifail = 'none';
        },1200)
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    // 点击改变字体颜色
    Myfontlr(fontindx){
      this.Myfodx = fontindx;
      console.log(this.Myfodx);
    },
    // 获取选中的余额的值
    MyBalanTion(){
      this.mybilong = 'block';
      this.$axios.post('wx/oldBillList',this.$qs.stringify({
        token: this.loginID,
        transactiontype: '1',
        type: this.Mybalance,
        cnumber: this.mytfbr
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        this.mybilong = 'none';
        if(res.data.code == '200'){
          this.mybifotn = res.data.data;
        }else{
          this.mybitips = res.data.msg;
          this.mybifail = 'block';
          const _this = this;
          setTimeout(function(){
            _this.mybifail = 'none';
          },1200)
        }
      })
      .catch(() => {
        console.log('获取失败');
      });
    },
    // 获取选中的积分的值
    MyIntegTion(){
      this.mybilong = 'block';
      this.$axios.post('wx/oldBillList',this.$qs.stringify({
        token: this.loginID,
        transactiontype: '2',
        type: this.MyIntegral,
        cnumber: this.mytfbr
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        this.mybilong = 'none';
        if(res.data.code == '200'){
          this.mybifotn = res.data.data;
        }else{
          this.mybitips = res.data.msg;
          this.mybifail = 'block';
          const _this = this;
          setTimeout(function(){
            _this.mybifail = 'none';
          },1200)
        }
      })
      .catch(() => {
        console.log('获取失败');
      });
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/MyBill.css";
</style>